export const ENDPOINTS = {
    IP_INFO: 'https://ipapi.co/json',
}

export const CS_CDN_ENDPOINTS = {
    SEARCH: (
        date: string,
        skip: number,
        rpp: number,
        filterBy: string,
        orderBy: string
    ) =>
        `&include_count=true&skip=${skip}&limit=${rpp}&query={"start_date":{"${[
            filterBy,
        ]}":"${date}"}}&${orderBy}=start_date`,
}

export const SYNDEO_API = {
    REQUEST_OTP: `/user-auth/request-otp`,
    VALIDATE_OTP: `/user-auth/validate-otp`,
    REFRESH_TOKEN: `/user-auth/refresh-token`,
    MY_INFO: `/user-api/myinfo`,
    MY_REPORT_TREATMENT: `report/myreport/treatment`,
    MY_REPORT_TREATMENT_DATA: `report/my-treatment-data`,
    PROVIDERS_ASSOCIATIONS: `/provider/my-esties`,
    PROVIDERS_PENDING_ASSOCIATIONS: `/provider/requests`,
    ESTIES_ASSOCIATIONS: '/esti/my-providers',
    ESTIES_PENDING_ASSOCIATIONS: '/esti/requests',
    ESTIE_REQUEST_PROVIDER: '/esti/request-provider-to-add-me',
    MAKE_USER_PROVIDER: '/provider/confirm-me',
    MAKE_USER_ESTI: '/esti/confirm-me',
    MAKE_USER_CLIENT: '/consumer/confirm-me',
    MARK_READ_PROVIDER: '/provider/markAsReadNewEsties',
    MARK_READ_ESTI: '/esti/markAsReadNewProviders',
    USER_HASH: '/user-api/getUserInfoHash',
    SYNDEO_BOOSTER: '/report/myreport/booster',
} as const

export const MIDDLELAYER_API = {
    ADD_ASSOCIATION: 'v2/provider-esti-request',
    CLIENT_LOOKUP: 'v2/provider/client-lookup',
    CREATE_TREATMENT_HISTORY: 'api/create-treatment-history',
    DELETE_REQUEST: 'v2/delete-request',
    GET_ACCOUNT: 'v2/get-account',
    GET_PROVIDER_ESTI: 'v2/get-provider-esti',
    GET_PROVIDER_LIST: 'v2/get-provider-list',
    LOYALTY_OPT_IN: 'v2/provider/loyalty-opt-in',
    LOYALTY_OPT_OUT: 'v2/provider/loyalty-opt-out',
    MANAGE_ASSOCIATION_REQUEST: 'v2/change-Request-Status',
    MARK_AS_READ: 'v2/read-new-provider-esti',
    MULTI_ACCOUNT_SIGN_UP: 'v2/sign-up-mlp',
    REFRESH_TOKEN: 'v2/refresh-token',
    REQUEST_OTP: 'v2/request-otp',
    REWARD_HISTORY: 'api/rewards-history',
    SEND_CONSUMER_INVITATION: 'v2/provider/send-consumer-invitation',
    SEND_ESTI_INVITATION: 'v2/send-esti-invitation',
    SIGNIN: 'v2/sign-in',
    SIGNUP: 'v2/sign-up',
    UPDATE_ACCOUNT: 'v2/update-account',
    VALIDATE_CUSTOMER_ID: 'v2/validate-customer-id',
    VALIDATE_PROVIDER_SIGN_UP_KEY: 'v2/provider/validate-provider-signup-key',
    VALIDATE_ESTI_SIGN_UP_KEY: 'v2/validate-esti-signup-key',
    UPDATE_BOOK_FORM_SUBMITTED_STATUS:
        'api/account/update-book-form-submitted-status',
    VALIDATE_BHCID: 'v2/validate-bhcid-id',
} as const
